import { render } from "./LazyImage.vue?vue&type=template&id=febd1ef0&scoped=true"
import script from "./LazyImage.vue?vue&type=script&lang=js"
export * from "./LazyImage.vue?vue&type=script&lang=js"

import "./LazyImage.vue?vue&type=style&index=0&id=febd1ef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-febd1ef0"]])

export default __exports__